export default __webpack_public_path__ + "static/media/logo.8108b6e6.png";